import React from 'react';

import styles from './styles.module.scss';

export enum SPINNER_TYPE {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  LIGHT = 'light',
}

export interface ISpinner {
  size?: number;
  type?: SPINNER_TYPE;
  style?: React.CSSProperties;
}

const Spinner = ({ size = 24, type = SPINNER_TYPE.DEFAULT, style }: ISpinner) => {
  return (
    <svg className={`${styles.container} ${styles[type]}`} width={size} height={size} viewBox="0 0 68 68" style={style || {}}>
      <circle className={styles.path} fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" cx="34" cy="34" r="30" />
    </svg>
  );
};

export default Spinner;
